import { usePublicProfile } from '_common/hooks';
import style from './UsernameLabel.module.scss';

type UsernameLabelProps = {
  userId?: UserId;
  name?: ParsedProfile<UserPublicProfile>['name'];
  displayEmail?: boolean;
  userName?: string;
};

const UsernameLabel = ({ userId = '', name = '', displayEmail, userName }: UsernameLabelProps) => {
  const profile = usePublicProfile(userId, name);

  if (profile.type === 'removed' && !userName) {
    return <span className={style.removed}>{profile.name}</span>;
  }

  return displayEmail ? (
    <div className={style.root}>
      {profile.name || name}
      <span className={style.email}>{profile.email}</span>
    </div>
  ) : (
    <>{userName || profile.name || name}</>
  );
};

export default UsernameLabel;
